(function (module) {
    'use strict';

    function AddSubAccountCtrl($state, SubAccount, Store) {
        this.$onInit = () => {

        };

        this.addSubAccount = () => {
            SubAccount
                .create(this.subAccount)
                .$promise
                .then((response) => {
                    Store.setSingleModelData('subAccounts', response.id, response);
                    $state.go('root.my-account.sub-accounts');
                })
                .catch((error) => {
                    return error;
                });
        };
    }

    module
        .config(($stateProvider) => {
            $stateProvider
                .state('root.my-account.sub-accounts.add', {
                    url: '/add',
                    data: {
                        pageTitle: 'SUB_ACCOUNTS_ADD.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<sub-account-add-component />',
                        },
                    },
                });
        })
        .component('subAccountAddComponent', {
            templateUrl: '/js/my-account/sub-accounts/add-sub-account/add-sub-account.html',
            controller: AddSubAccountCtrl,
        });
})(angular.module('rocket.components'));
